"use strict";

var UserProfile = require('bunsen/models/identity/UserProfile');
var UserProProfile = UserProfile.extend();

module.exports = UserProProfile;

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var endpoints = require('dibs-endpoints');

_.extend(UserProProfile.prototype, {
    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.userProProfile(this.parents[0].id);
    },
    relations: function () {
        return [
            {
                key: 'trade',
                relatedModel: UserProfile,
                type: Backbone.One
            }
        ];
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/UserProProfile.js
// module id = 2042
// module chunks = 62